<template>
  <el-dropdown trigger="hover" class="cursor-pointer">
    <div class="flex items-center cursor-pointer">
      <el-avatar :size="32" class="bg-primary">{{ user.email?.charAt(0) }}</el-avatar>
      <span class="ml-2">{{ user.email || t('user.fields.unnamed') }}</span>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item>
          <Link href="#" class="w-full block">{{ t('components.userDropdown.profile') }}</Link>
        </el-dropdown-item>
        <el-dropdown-item>
          <Link href="#" class="w-full block">{{ t('components.userDropdown.settings') }}</Link>
        </el-dropdown-item>
        <el-divider style="margin: 4px 0" />
        <el-dropdown-item>
          <Link :href="routes.session()" method="delete" as="button" class="w-full text-left">{{ t('components.userDropdown.logout') }}</Link>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { Link } from '@inertiajs/vue3'

const { t } = useI18n()

defineProps({
  user: {
    type: Object,
    required: true,
  },
})
</script> 